import { HttpClient } from "../HttpClient";

export const PostBulkArchive = async (ids) => {
  try {
    const { data } = await HttpClient.post(`api/ClipSubmissions/BulkArchive`, ids);
    return data;
  } catch (err) {
    console.error("Error archiving claim submissions:", err);
    return null;
  }
};
